import { http } from './http';
import { ROUTES } from './config';
import type {
  CatalogAreaAdmin,
  CatalogAreaInput,
  CatalogItemAdmin,
  CatalogItemInput,
  CatalogPackageInput,
} from '../types/domain';

/**
 * CatalogAdminController client (manager+) — the tenant's pricing console.
 * Areas and items have a real admin list/get (incl. inactive rows); packages don't — the
 * public catalog (bookingApi.getCatalog() / useCatalog()) already returns package `id`,
 * so admin package reads reuse that instead.
 */
export const catalogAdminApi = {
  listAreas(): Promise<CatalogAreaAdmin[]> {
    return http.get(`${ROUTES.catalogAdmin}/service-areas`);
  },
  createArea(body: CatalogAreaInput): Promise<{ id: string; code: string }> {
    return http.post(`${ROUTES.catalogAdmin}/service-areas`, body);
  },
  updateArea(id: string, body: CatalogAreaInput): Promise<void> {
    return http.put(`${ROUTES.catalogAdmin}/service-areas/${id}`, body);
  },
  deleteArea(id: string): Promise<void> {
    return http.delete(`${ROUTES.catalogAdmin}/service-areas/${id}`);
  },

  createPackage(body: CatalogPackageInput): Promise<{ id: string; code: string }> {
    return http.post(`${ROUTES.catalogAdmin}/packages`, body);
  },
  updatePackage(id: string, body: CatalogPackageInput): Promise<void> {
    return http.put(`${ROUTES.catalogAdmin}/packages/${id}`, body);
  },
  deletePackage(id: string): Promise<void> {
    return http.delete(`${ROUTES.catalogAdmin}/packages/${id}`);
  },

  listItems(): Promise<CatalogItemAdmin[]> {
    return http.get(`${ROUTES.catalogAdmin}/items`);
  },
  createItem(body: CatalogItemInput): Promise<{ id: string; code: string }> {
    return http.post(`${ROUTES.catalogAdmin}/items`, body);
  },
  updateItem(id: string, body: CatalogItemInput): Promise<void> {
    return http.put(`${ROUTES.catalogAdmin}/items/${id}`, body);
  },
  deleteItem(id: string): Promise<void> {
    return http.delete(`${ROUTES.catalogAdmin}/items/${id}`);
  },
};
